import type { SVGProps } from "react";
const SvgIconDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <rect width={285} height={50} x={322} y={310} rx={25} />
    <rect width={380} height={50} x={322} y={563} rx={25} />
    <rect width={380} height={50} x={322} y={463} rx={25} />
    <rect width={380} height={50} x={322} y={663} rx={25} />
    <path d="M752 210v603H272V210zm0-50H272a50 50 0 0 0-50 50v603a50 50 0 0 0 50 50h480a50 50 0 0 0 50-50V210a50 50 0 0 0-50-50" />
  </svg>
);
export default SvgIconDocument;
